import $ from 'jquery';
import slick from 'slick-carousel';

var $logoModules = $( '.js-logo-module' );

if ( $logoModules.length > 0 ) {
	$logoModules.each( function() {
		$( this ).find( '.js-logo-module-navigation' ).slick( {
			asNavFor: '.js-logo-module-slider',
			slidesToShow: 2,
			focusOnSelect: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 2500,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 6,
					}
				},
			]
		} );

		$( this ).find( '.js-logo-module-slider' ).slick( {
			asNavFor: '.js-logo-module-navigation',
			arrows: false,
			fade: true,
			autoplay: true,
			autoplaySpeed: 2500,
			adaptiveHeight: true,
		} );
	} );
}
